import { inject } from '@angular/core';
import { RedirectFunction } from '@angular/router';
import { AccessControl } from 'src/app/shared/authentication/access-control';
import { AuthService } from 'src/app/shared/authentication/auth.service';

/** Redirects `/` to the Enterprise Dashboard for users with its permission, otherwise to alerts as before. */
export const rootRedirect: RedirectFunction = async () => {
  const auth = inject(AuthService);
  await auth.getCurrentUser().catch((): undefined => undefined);
  return auth.hasPermission(AccessControl.FeatureEnterpriseDashboard) ? 'dashboard' : 'alerts';
};
